import type { MerchantProfile } from '@/modules/auth/types/Merchants';
import type { Media } from './Media';
import type { ProductVariant } from './Product';

export interface CartProductPivot {
  id?: number;
  cart_id?: number;
  product_id: number;
  quantity: number;
  price_in_cents: number;
  product_variant_id?: number | null;
}

export interface CartProduct {
  /** Stable id for the cart line (cart_product row). Prefer for list keys and UI identity. */
  cart_line_id?: number;
  id: number;
  title: string;
  description: string;
  quantity: number;
  /** Line-level images: API may return product photos, variant-specific photos, or merged line photos. */
  photos: Media[];
  pivot: CartProductPivot;
  variant?: ProductVariant | null;
  is_deleted: boolean;
}

export interface Cart {
  id?: number;
  customer_id?: number;
  merchant_id: number;
  merchant: MerchantProfile;
  products: CartProduct[];
  subtotal: number;
  subtotal_formatted: string;
}

export const CART_INCLUDES =
  'cartProducts.photos,cartProducts.variant' as const;

export function cartLineKey(line: CartProduct): string {
  if (line.cart_line_id != null) return String(line.cart_line_id);
  if (line.pivot?.id != null) return String(line.pivot.id);
  const variantPart =
    line.pivot?.product_variant_id != null
      ? String(line.pivot.product_variant_id)
      : 'simple';
  return `${line.id}-${variantPart}`;
}
